import { render } from "./EditClientView.vue?vue&type=template&id=49fa485a"
import script from "./EditClientView.vue?vue&type=script&lang=js"
export * from "./EditClientView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__